import React, { useRef, useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import { MAX_CURRENCY } from '../../shared/constants';
import { getCurrentYear } from '../../shared/shared';
import Papa from "papaparse";
import { CSVLink } from 'react-csv';

const FileDragAndDrop = (props) => {
    const [state, setState] = useState({
        file: null,
        data: {},
        messages: [],
        fileName: null
    });

    const drop = useRef(null)
    const colorValidation = props.valid ? '#aaa' : 'red';

    const changeHandler = (event) => {
        setFile(event.target.files[0])
    };

    useEffect(() => {
        drop.current.addEventListener('dragover', handleDragOver);
        drop.current.addEventListener('drop', handleDrop);
    }, []);

    useEffect(() => {
        if (props.fileInput.data == null || props.fileInput.data == undefined) return;
        if (props.fileInput.data.length == 0) return;
        processData({ data: props.fileInput.data }, { name: props.fileInput.fileName })
    }, [])

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { files } = e.dataTransfer;

        if (files && files.length) {
            setFile(files[0])
        }
    };

    const camelCaseNormalize = {
        distribution: "Distribution",
        netCashValue: "Net Cash Value",
        netDeathBenefits: "Net Death Benefits",
        premiumOutlay: "Premium Outlay"
    }

    const headers = [
        { label: 'Distribution', key: 'distribution' },
        { label: 'Net Cash Value', key: 'netCashValue' },
        { label: 'Net Death Benefits', key: 'netDeathBenefits' },
        { label: 'Premium Outlay', key: 'premiumOutlay' },
        { label: 'Year', key: 'year' }
    ];

    const setErrors = (data) => {

        if (data.length === 0) return ['Please add at least one line in the CSV file']

        const validateColumnNames = Object.keys(data[0])
            .filter(header => !{ ...camelCaseNormalize, year: 0 }.hasOwnProperty(header))

        if (validateColumnNames.length > 0) {
            return [`Please check that the file’s header names are Distribution, Net Cash Value, Net Death Benefits, Premium Outlay, and Year.`]
        }

        return data.map((dataColumn, idx) => {
            const differenceOfColumns = Object.keys(camelCaseNormalize)
                .sort()
                .filter(function (e) {
                    return Object.keys(dataColumn).sort().indexOf(e) === -1;
                });

            if (differenceOfColumns.length > 0) {
                const wrongColumns = differenceOfColumns.map(column => camelCaseNormalize[column])
                return `${wrongColumns} missing data in rows ${idx + 2}. Please check and upload again.`
            }

            const findNoFloatValues = Object.entries(dataColumn).filter(element =>
                isNaN(parseFloat(element[1])) || parseFloat(element[1]) >= MAX_CURRENCY)

            if (findNoFloatValues.length > 0) {
                const wrongColumns = Object
                    .keys(Object.fromEntries(findNoFloatValues))
                    .map(column => camelCaseNormalize[column])
                    .toString();

                return `CSV files cannot contain formatting. Data in ${wrongColumns} need formatting to be removed. Please check row ${idx + 2} and then upload again.`
            }

        }).filter(notUndefined => notUndefined !== undefined);
    }

    const processData = (results, file) => {
        const fileToJson = results.data.map((e, idx) => {
            e.year = getCurrentYear() + idx
            return Object.fromEntries(
                Object.entries(e).map(e => [e[0].charAt(0).toLocaleLowerCase() + e[0].slice(1).replace(/\s/g, ""), e[1]]
                ))
        });
        const errs = setErrors(fileToJson);
        props.setFileInput((v) => ({ ...v, data: fileToJson, messages: errs, fileName: file.name }))
    }

    const setFile = (file) => {
        if (file.type !== "text/csv") {
            props.setFileInput((v) => ({ ...v, messages: ["This file type is not supported. Please upload a CSV file."], fileName: file.name }))
            return;
        }
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: processData
        });
    }

    return (
        <Grid style={{ border: `1px ${colorValidation} solid`, width: '92%', }}>
            <div
                item xs={11}
                display={!state.showInfoFile ? 'flex' : 'none'}
                className={"container-custom-file-input"}
            >
                <label
                    htmlFor={`file-upload-${props.index}`}
                    className={"custom-file-upload"}>
                    Choose File
                </label>
                <input
                    style={{ display: 'none' }}
                    value={''}
                    id={`file-upload-${props.index}`}
                    type={"file"}
                    onChange={changeHandler}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <div
                    className='FilesDragAndDrop__area'
                    ref={drop}
                >
                    Drag and Drop here.
                    <span
                        role='img'
                        aria-label='emoji'
                        className='area__icon'
                    >
                    </span>
                </div>

            </div>

            {(props.fileInput.messages.length > 0 &&
                <Grid item xs={12} ml={'16px'} >
                    <Typography> File {props.fileInput.fileName} not valid </Typography>
                    <ol style={{ margin: '0' }}>
                        {props.fileInput.messages.map((item, idx) =>
                            <li key={idx} className={"error-list-csv-file"} > {item} </li>
                        )}
                    </ol>

                </Grid>
            )}

            {(props.fileInput.data !== null) &&
                <Grid item xs={12} >

                    <Grid container>
                        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", padding: '0.3em 1em' }}>
                            <div style={{ display: 'flex' }}>

                                <CSVLink
                                    headers={headers}
                                    data={props.fileInput.data}
                                    filename={props.fileInput.fileName != null ? props.fileInput.fileName : "Guaranteed Income.csv"}
                                >
                                    <SimCardDownloadIcon
                                        style={{ color: '#555555', fontSize: '45px' }}
                                        onClick={() => console.log("DOWNLOAD THE FILE CSV")}
                                    />
                                </CSVLink>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Typography component={"label"} display={'flex'} flexDirection={'column'}>
                                        {props.fileInput.fileName != null ? props.fileInput.fileName : "Guaranteed Income.csv"}
                                    </Typography>
                                </div>
                            </div>
                            <DeleteIcon onClick={props.cleanFile} />
                        </Grid>
                    </Grid>
                </Grid>
            }

        </Grid>
    );
}

export default FileDragAndDrop;